<template>
  <div class="filter">
    <div class="name" :class="{ 'no-border': step === 3 }">{{ name }}</div>

    <div class="select" :class="{ 'no-border': step === 3 }">
      <select class="form-select" :name="fieldName" v-model.lazy="value">
        <option
            v-for="opt in visibleOptions"
            :key="String(opt.value)"
            :value="opt.value"
        >
          {{ t(opt.label) }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
import { watch, ref, computed } from "vue";
import { isSG } from "@/config/appVersion";

export default {
  name: "SelectFilter",
  props: {
    name: String,
    fieldName: String,
    type: String,
    store: Object,
    selected: {
      type: [String, Number],
      default: "",
    },
    step: {
      type: Number,
      default: 1,
    },
  },
  setup(props) {
    const value = ref(
        props.store?.filters?.[props.fieldName] !== undefined &&
        props.store?.filters?.[props.fieldName] !== null &&
        props.store?.filters?.[props.fieldName] !== ""
            ? props.store.filters[props.fieldName]
            : ""
    );

    const rawOptions = computed(() => {
      return props.type === "direction"
          ? props.store?.directionColumns
          : props.store?.orderByColumns;
    });

    // Normalizacja: wspiera array i object, zachowując dotychczasowe "index" jako value
    // - array:  [{label: option, value: index}]
    // - object: [{label: objValue, value: objKey}]
    const normalizedOptions = computed(() => {
      const base = rawOptions.value;

      if (Array.isArray(base)) {
        return base.map((label, idx) => ({ label, value: idx }));
      }

      if (base && typeof base === "object") {
        // zachowujemy kolejność wstawiania kluczy
        return Object.entries(base).map(([key, label]) => ({ label, value: key }));
      }

      return [];
    });

    const visibleOptions = computed(() => {
      const opts = normalizedOptions.value;
      return isSG ? opts.slice(0, 2) : opts;
    });

    const saveValue = (val) => {
      props.store?.addItem?.(props.fieldName, val);
    };

    watch(value, (newValue) => {
      saveValue(newValue);
    });

    // Jeśli isSG i aktualna wartość jest spoza 2 pierwszych opcji, czyścimy ją (żeby nie trzymać niewidocznej)
    watch(
        () => visibleOptions.value,
        (opts) => {
          if (!isSG) return;

          const allowed = new Set(opts.map((o) => String(o.value)));
          const current = String(value.value);

          if (current !== "" && !allowed.has(current)) {
            value.value = "";
            saveValue("");
          }
        },
        { immediate: true }
    );

    return { value, visibleOptions, isSG };
  },
};
</script>

<style scoped>
.name {
  padding: 17px 0 16px 16px;
  font-size: 16px;
  background-color: white;
}

.select {
  height: 47px;
}

.name.no-border,
.select.no-border {
  border-bottom: none !important;
}

.form-select {
  max-width: 275px;
}
</style>
